//@flow
import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import {colors} from '../../assets/styles/colors';
import {IconButton, Typography} from '@material-ui/core';
import {Add, Remove} from '@material-ui/icons';
import CustomTextField from '../CustomTextField/CustomTextField';

const useStyles = makeStyles(theme => ({
  quantity: {
    display: 'flex',
    alignItems: 'center',
  },
  quantityButton: {
    border: `1px solid ${colors.grey300}`,
  },
  quantityAmount: {
    width: 40,
    textAlign: 'center',
    fontWeight: 500,
    fontSize: '0.875rem',
  },
  textField: {
    margin: theme.spacing(0, 2),
    width: 80,
  },
  textInput: {
    height: 36,
    boxSizing: 'border-box',
  },
}));

type Props = {|
  size?: 'sm' | 'md',
  value: number,
  minValue?: number,
  maxValue?: number,
  removeHandler: () => void,
  addHandler: () => void,
  type?: number,
  setQuantity?: (a: any) => void,
|};

export default function Quantity(props: Props) {
  const {
    // size = 'md',
    value,
    minValue = 1,
    maxValue,
    removeHandler,
    addHandler,
    type = 1,
    setQuantity,
  } = props;
  const classes = useStyles();

  const onChange = e => {
    if (setQuantity) {
      if (e.target.value) {
        setQuantity(parseInt(e.target.value));
      } else if (e.target.value === '') {
        setQuantity(0);
      }
    }
  };
  return (
    <div className={`${classes.quantity}`}>
      <IconButton
        className={classes.quantityButton}
        size="small"
        onClick={_ => removeHandler()}
        disabled={value <= minValue}
      >
        <Remove fontSize="small" />
      </IconButton>
      {type === 1 ? (
        <Typography className={classes.quantityAmount}>{value}</Typography>
      ) : (
        <CustomTextField
          className={classes.textField}
          onChange={e => onChange(e)}
          value={value}
          InputProps={{classes: {input: classes.textInput}}}
          type="number"
        />
      )}
      <IconButton
        className={classes.quantityButton}
        size="small"
        onClick={_ => addHandler()}
        disabled={typeof maxValue === 'number' && maxValue <= value}
      >
        <Add fontSize="small" />
      </IconButton>
    </div>
  );
}

Quantity.propTypes = {
  size: PropTypes.string,
  value: PropTypes.number.isRequired,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  removeHandler: PropTypes.func.isRequired,
  addHandler: PropTypes.func.isRequired,
  type: PropTypes.number,
};
